export function ComplianceBadge({ kind, value }) {
  const map = {
    risk_level: {
      low: { bg: "#E8F1EA", color: "#0B6623", border: "#0B6623", label: "RISK · LOW" },
      medium: { bg: "#FFF7E6", color: "#9A6B00", border: "#F5A623", label: "RISK · MEDIUM" },
      high: { bg: "#FCEBED", color: "#A30414", border: "#D0021B", label: "RISK · HIGH" },
      restricted: { bg: "#111216", color: "#FFF", border: "#111216", label: "RESTRICTED" },
      do_not_sell: { bg: "#111216", color: "#FFF", border: "#111216", label: "DO NOT SELL" },
    },
    legal_review_status: {
      approved: { bg: "#E8F1EA", color: "#0B6623", border: "#0B6623", label: "LEGAL · APPROVED" },
      pending: { bg: "#FFF7E6", color: "#9A6B00", border: "#F5A623", label: "LEGAL · PENDING" },
      rejected: { bg: "#FCEBED", color: "#A30414", border: "#D0021B", label: "LEGAL · REJECTED" },
    },
    us_sale_status: {
      allowed: { bg: "#E8F1EA", color: "#0B6623", border: "#0B6623", label: "US · ALLOWED" },
      manual_review: { bg: "#FFF7E6", color: "#9A6B00", border: "#F5A623", label: "US · MANUAL REVIEW" },
      prohibited: { bg: "#FCEBED", color: "#A30414", border: "#D0021B", label: "US · PROHIBITED" },
    },
    coa: {
      active: { bg: "#E8F1EA", color: "#0B6623", border: "#0B6623", label: "COA · ACTIVE" },
      expired: { bg: "#FFF7E6", color: "#9A6B00", border: "#F5A623", label: "COA · EXPIRED" },
      recalled: { bg: "#FCEBED", color: "#A30414", border: "#D0021B", label: "COA · RECALLED" },
      under_review: { bg: "#F7F7F8", color: "#111216", border: "#5E636E", label: "COA · UNDER REVIEW" },
    },
    order_status: {
      pending_manual_review: { bg: "#FFF7E6", color: "#9A6B00", border: "#F5A623", label: "PENDING REVIEW" },
      approved: { bg: "#E8F1EA", color: "#0B6623", border: "#0B6623", label: "APPROVED" },
      shipped: { bg: "#EAF3FF", color: "#003366", border: "#003366", label: "SHIPPED" },
      rejected: { bg: "#FCEBED", color: "#A30414", border: "#D0021B", label: "REJECTED" },
    },
  };
  const cfg = map[kind]?.[value] || { bg: "#F7F7F8", color: "#111216", border: "#D1D5DB", label: String(value || "—").toUpperCase() };
  return (
    <span className="compliance-pill" style={{ background: cfg.bg, color: cfg.color, borderColor: cfg.border }} data-testid={`badge-${kind}-${value}`}>
      {cfg.label}
    </span>
  );
}
